module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic51.de93fdc.woff2";